// ── Board card description (TPT465, TPT620) ──
//
// The description HTML both board cards render: kanban.js renderKanbanCard() and
// sprint-board.js renderCard(). Markdown goes through the sandboxed renderSafeMarkdown()
// (safe-markdown.js), never utils.js's unsanitized renderer.
//
// Board rows are `fields=board` (TPT597): `description` is at most a 600-character prefix and
// `description_truncated` is true when the server cut it. A cut prefix ends with a marker, "…"
// plus a pointer to the full task, so the hover-expand overlay (hover-expand.js), which shows
// the whole rendering, never stops mid-sentence with no sign that more text exists. The marker
// is appended after the rendered Markdown rather than to the Markdown source: wherever the cut
// lands (an unclosed code fence, a link reference definition, a bare URL), that construct can
// neither swallow the marker nor restyle it. A row without the flag (a full row, e.g. a PATCH
// reply swapped into the board) holds the whole text and gets no marker.
//
// Leaf module on purpose: imports only safe-markdown.js (which imports only `marked`), so it
// is node-testable with a plain static import.
import { renderSafeMarkdown } from './safe-markdown.js';

const TRUNCATED_MARKER = '<p class="card-desc-more">… Open the task for the full description</p>';

// Card description HTML for a task row, or '' when there is nothing to show.
export function renderCardDescription(task) {
  const desc = (task.description || '').trim();
  const truncated = task.description_truncated === true;
  if (!desc && !truncated) return '';
  return renderSafeMarkdown(desc) + (truncated ? TRUNCATED_MARKER : '');
}
